import $ from 'jquery';
import _ from 'underscore';
import BaseView from 'picnic/core/views/Base';
import BrandSelect from 'app/cms/carpricechecker/views/BrandSelect';
import ModelSelect from 'app/cms/carpricechecker/views/ModelSelect';
import AdditionalFields from 'app/cms/carpricechecker/views/AdditionalFields';
import AppointmentsSelect from 'app/cms/carpricechecker/views/AppointmentsSelect';
import Result from 'app/cms/carpricechecker/views/Result';
import BrandModels from 'app/cms/carpricechecker/collections/BrandModels';


class View extends BaseView {

	render() {
		this._events();
		this._brandModels = new BrandModels();
		this._brandValue = '';
		this._renderBrandSelect();
		this._renderModelSelect();
		this._renderAdditionalFields();
		this._renderAppointmentsSelect();
		this._renderResult();
		this._showForm(this._brandSelect.$el.find('select').val());

		return this;
	}

	_events() {
		_.bindAll(
			this,
			'_onBrandSelected',
			'_onScrollToCarpricechecker'
		);

		this.context.vent.on('scrollToCarpricechecker:cpc-warning', this._onScrollToCarpricechecker);
	}

	_renderBrandSelect() {
		this._brandSelect = new BrandSelect({
			el: this.$el.find('.field-brand'),
			context: this.context
		}).render();

		this._brandSelect.on('selected', this._onBrandSelected);
	}

	_renderModelSelect() {
		this._modelSelect = new ModelSelect({
			el: this.$el.find('.field-model'),
			context: this.context,
			collection: this._brandModels
		}).render();
	}

	_renderAdditionalFields() {
		this._additionalFields = new AdditionalFields({
			el: this.$el.find('.optional-filter'),
			context: this.context
		}).render();
	}

	_renderAppointmentsSelect() {
		this._appointmentsSelect = new AppointmentsSelect({
			el: this.$el.find('.row-features'),
			context: this.context
		}).render();
	}

	_renderResult() {
		var $el = this.$el.find('.result');

		if ($el.length) {
			this._result = new Result({
				el: $el,
				context: this.context
			}).render();
		}
	}

	_resetForm() {
		this._brandModels.reset();
		this._modelSelect.deactivate();
		this._additionalFields.deactivate();
	}

	_showForm(value) {
		if (!value) {
			return;
		}

		var
			models = [{
				value: '',
				text: ''
			}]
		;

		window.kleinanzeigen.carlist[value].models.forEach(function(model) {
			models.push({
				value: model[0],
				text: model[1]
			});
		});

		this._brandModels.reset();
		this._brandModels.add(models);
		this._additionalFields.activate();
		this._modelSelect.createChildview(models);
		this._modelSelect.activate();
	}

	_onBrandSelected(data) {
		const value = data.selectedValue;

		if (value === this._brandValue) {
			return;
		}

		if (value === '') {
			this._resetForm();
		} else {
			this._showForm(value);
		}

		this._brandValue = value;
	}

	_onScrollToCarpricechecker() {
		var
			$el = $('#carpricechecker'),
			offset = $('.header').height() || 120
		;

		if ($el.length) {
			$('body, html').animate({
				scrollTop: $el.offset().top - offset
			}, 500);
		}
	}

}

export default View;
